import React, { Component } from 'react';
import { routerActions } from 'connected-react-router';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {Table, Dropdown, Checkbox, Input, Icon} from 'semantic-ui-react';
import * as Reservation from '../../store/Reservations';
import * as Events from '../../store/Events';
import * as Facilities from '../../store/Facility';
import RefreshButton from '../../components/RefreshButton';

// function unique (array, prop) {
//     return array.filter((value, index, self) => {
//         return self.map(item => item[prop]).indexOf(value[prop]) === index;
//     })
// }
class ReservationList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            facilityId: 'all',
            eventId: 'all',
            search: '',
            loading: []
        }
        this.onFilter = this.onFilter.bind(this);
        this.onEdit = this.onEdit.bind(this);
        this.onSearch = this.onSearch.bind(this);
        this.onMailed = this.onMailed.bind(this);
    }

    async onMailed(e, {data, checked}){
        console.log(data, checked);
        const {actions} = this.props;
        const {loading} = this.state;
        this.setState({loading: [...loading, data.id]});
        try {
            const reservation = await actions.getReservation(data.number);
            console.log(reservation);
            await actions.updateReservation({...reservation.response, isMailed: checked});
            await actions.getReservations(data.id);
            this.setState({loading: loading.filter(item => item === data.id)})
        } catch (error) {
            this.setState({loading: loading.filter(item => item === data.id)})
        }
    }
    onFilter(e, {name, value}) {
        this.setState({[name]: value});
    }
    onEdit(e) {
        e.preventDefault();
        const {actions} = this.props;
        actions.push(e.target.pathname);
    }

    onSearch(e, {name, value}) {
        this.setState({search: value});
    }
    
    render() {
        const {reservations, facilities, events, actions} = this.props;
        const {facilityId, eventId, search, loading} = this.state;
        console.log(facilityId, eventId);
        let unmailedQuery = "";
        if (facilityId !== 'all' || eventId !== 'all') {
            
            const facilityQuery = facilityId !== 'all' ? `facilityid=${facilityId}` : '';
            const eventQuery = eventId !== 'all' ? `eventid=${eventId}` : '';
            unmailedQuery = facilityQuery.length && eventQuery.length ? `?${facilityQuery}&${eventQuery}` : facilityQuery.length ? `?${facilityQuery}` : `?${eventQuery}`;
        }
        return (
            <div>
                <Table>
                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell colspan={5}>Reservations</Table.HeaderCell>
                            <Table.HeaderCell colspan={3}><Input placeholder="Search..." onChange={this.onSearch} value={search} /></Table.HeaderCell>
                        </Table.Row>
                        <Table.Row>
                            <Table.HeaderCell>
                                <Dropdown selection fluid name='facilityId' value={facilityId} options={[{text: 'All', value: 'all'}, ...facilities]} onChange={this.onFilter} />
                            </Table.HeaderCell>
                            <Table.HeaderCell>
                                <Dropdown selection fluid name='eventId' value={eventId} options={[{text: 'All', value: 'all'}, ...events]} onChange={this.onFilter} />
                            </Table.HeaderCell>
                            <Table.HeaderCell>Confirmation</Table.HeaderCell>
                            <Table.HeaderCell>Parker</Table.HeaderCell>
                            <Table.HeaderCell>Status</Table.HeaderCell>
                            <Table.HeaderCell>Paid</Table.HeaderCell>
                            <Table.HeaderCell>Mailed</Table.HeaderCell>
                            <Table.HeaderCell><RefreshButton floated="right" action={async () => await actions.getReservations()} /><a href={`/api/reservation/unmailed${unmailedQuery}`} download="Unmailed.csv">Unmailed</a></Table.HeaderCell>
                        </Table.Row>
                    </Table.Header>
                    <Table.Body>
                        {reservations.filter(r => facilityId === 'all' ? true : r.facilityId === facilityId).filter(r => eventId === 'all' ? true : r.eventId === eventId)
                        .filter(r => search.length ? r.number === parseInt(search, 10) || r.parkerName.toLowerCase().includes(search.toLowerCase()) : true).sort((a, b) => {
                            if (a.facilityName > b.facilityName) return 1;
                            if (a.facilityName < b.facilityName) return -1;
                            if (a.eventName > b.eventName) return 1;
                            if (a.eventName < b.eventName) return -1;
                            if (a.number < b.number) return 1;
                            if (a.number > b.number) return -1;
                            return 0;
                         }).map((r, index) => (
                            <Table.Row>
                                <Table.Cell>{r.facilityName}</Table.Cell>
                                <Table.Cell>{r.eventName}</Table.Cell>
                                <Table.Cell><a href={`/admin/reservation/${r.number}`} onClick={this.onEdit}>{r.number}</a></Table.Cell>
                                <Table.Cell><a href={`/admin/reservation/${r.number}`} onClick={this.onEdit}>{r.parkerName}</a></Table.Cell>
                                <Table.Cell>{r.status}</Table.Cell>
                                <Table.Cell><Checkbox checked={r.isPaid} disabled /></Table.Cell>
                                <Table.Cell>{loading.includes(r.id) ? <Icon loading name='spinner' /> : <Checkbox data={r} checked={r.isMailed} onChange={this.onMailed} disabled={r.status === 'Cancelled'} />}</Table.Cell>
                            </Table.Row>
                        ))}
                    </Table.Body>
                    <Table.Footer>
                        <Table.Row>
                        <Table.HeaderCell colspan={8}></Table.HeaderCell>
                        </Table.Row>
                    </Table.Footer>
                </Table>
            </div>
        );
    }
}

ReservationList.propTypes = {

};

const mapStateToProps = (state, ownProps) => {
    return {
        reservations: Object.values(Reservation.selector(state).reservations),
        events: Object.values(Events.selector(state).events).map(evt => ({value: evt.id, text: evt.name})),
        facilities: Object.values(Facilities.selector(state).facilities).map(f => ({value: f.id, text: f.name})),
    }
}

const mapDispatchToProps = (dispatch) => ({
    actions: {
        ...bindActionCreators(routerActions, dispatch),
        ...bindActionCreators(Reservation.actionCreators, dispatch),
    }
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ReservationList));